import styled from '@emotion/styled';
import { Swiper } from 'swiper/react';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const ContentContainer = styled.div`
	width: 100%;
	padding: 2rem;

	@media ${Breakpoints.tablet} {
		padding: 1rem !important;
	}
`;

export const PageHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	margin-bottom: 2.5rem;

	@media ${Breakpoints.tablet} {
		padding: 1rem !important;
	}
`;

export const MainLayout = styled.div`
	display: grid;
	grid-template-columns: 3fr 1fr;
	grid-gap: 3rem;
	grid-template-areas: 'CentralArea Announcements';

	@media ${Breakpoints.desktop} {
		grid-template-columns: 1fr 1fr;
	}

	@media ${Breakpoints.tablet} {
		grid-template-columns: unset;
		grid-template-areas:
			'Announcements'
			'CentralArea';
	}
`;

export const CentralArea = styled.div`
	grid-area: CentralArea;
	display: flex;
	flex-direction: column;
	gap: 2.5rem;

	@media ${Breakpoints.tablet} {
		width: 100%;
		gap: 3rem;
	}
`;

export const Announcements = styled(Card)`
	grid-area: Announcements;
	border: none !important;
	width: 352px;
	height: 735px;

	@media ${Breakpoints.tablet} {
		width: 100%;
		height: 342px;
	}
`;

export const ProgressHeader = styled.div`
	margin-top: 1.5rem;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 2rem;
`;

export const ProgressBarWrapper = styled.div`
	width: 100%;
`;

export const ProgressCaption = styled.div`
	display: grid;
	grid-template-columns: 1rem max-content;
	align-items: center;
	justify-content: end;
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: var(--black-10);
	margin-top: var(--margin-4);
	margin-bottom: var(--margin-1);
`;

export const HelpCardsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 2rem;
	width: 100%;

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const SectionWrapper = styled.div`
	border-radius: var(--small-border-radius);
	background: var(--white);
	border: 1px solid var(--border-color);
	padding: 2rem;
`;

export const HelpButton = styled(SectionWrapper)`
	flex-grow: 1;
	display: grid;
	grid-template-columns: 6rem 1fr 2.5rem;
	gap: 2rem;
	align-items: center;
	cursor: pointer;
	border: 1px solid var(--white);
	background: var(--input-bg-color);

	:hover {
		background: var(--table-active-color);
		border: 1px solid var(--blue-20);

		& > .image-wrapper {
			background-color: var(--white);
		}
		& > .nav-icon {
			background-color: var(--white);

			& > .icon {
				color: var(--black);
			}
		}
	}
`;

export const SwiperWrapper = styled(Swiper)`
	height: 100%;

	& > .swiper-pagination {
		bottom: 3rem !important;
	}
`;

export const OnboardingSectionWrapper = styled.div`
	background: var(--white);
	border: 1px solid var(--border-color);
	padding: 2.58rem 2.58rem 0.5rem 2.58rem;
	border-radius: var(--medium-border-radius);

	@media ${Breakpoints.tablet} {
		padding: 2rem;
	}
`;

export const SupportCardButton = styled.div`
	border-radius: 50%;
	width: 2.5rem;
	height: 2.5rem;
	padding: 0.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: auto;
	background-color: transparent;

	& > .icon {
		color: var(--white);
	}

	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}
`;

export const ImageWrapper = styled.div`
	width: 6rem;
	height: 6rem;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;

	background-color: var(--blue-10);

	:hover {
		background-color: var(--white);
	}
`;
